$(function() {
    svg_icons.load('/images/icons-public.svg');

    $('.js-header-nav_item-menu').on('click', function(e) {
		e.preventDefault();
		$('.js-header').toggleClass('header_mobile-open');
	});

	// on window resize, we want to "close" the mobile menu
	$(window).on('resize', function() {
		$('.js-header').removeClass('header_mobile-open');

	});

	$('.service-list_item').on('click', function() {
		$('.hp_service-copy').removeClass('hp_service-visible');
		$('.service-list_item').removeClass('active');
		$(this).addClass('active');
	});

	$('.js-service-list_item-lymphatic').on('click', function() {
		$('.hp_service-copy-lymphatic').toggleClass('hp_service-visible')
		.focus();
	});

	$('.js-service-list_item-myofascial').on('click', function() {
		$('.hp_service-copy-myofascial').toggleClass('hp_service-visible')
		.focus();
	});

	$('.js-service-list_item-deep_tissue').on('click', function() {
		$('.hp_service-copy-deep_tissue').toggleClass('hp_service-visible')
		.focus();
	});

	$('.js-service-list_item-maternity').on('click', function() {
		$('.hp_service-copy-maternity').toggleClass('hp_service-visible')
		.focus();
	});

	$('.js-service-list_item-trigger_point').on('click', function() {
		$('.hp_service-copy-trigger_point').toggleClass('hp_service-visible')
		.focus();
	});

	$('.js-service-list_item-swedish').on('click', function() {
		$('.hp_service-copy-swedish').toggleClass('hp_service-visible')
		.focus();
	});

	$('.js-service-list_item-sdtt').on('click', function() {
		$('.hp_service-copy-sdtt').toggleClass('hp_service-visible')
		.focus();
	});

});